// Vue & Plugins
import { App } from 'vue'

// PrimeVue
import PrimeVue from 'primevue/config'
import { definePreset } from '@primevue/themes'
import Nora from '@primevue/themes/nora'
// Form
import AutoComplete from 'primevue/autocomplete'
import Calendar from 'primevue/calendar'
import DatePicker from 'primevue/datepicker'
import Checkbox from 'primevue/checkbox'
import ColorPicker from 'primevue/colorpicker'
import InputText from 'primevue/inputtext'
import InputGroup from 'primevue/inputgroup'
import InputGroupAddon from 'primevue/inputgroupaddon'
import InputMask from 'primevue/inputmask'
import InputNumber from 'primevue/inputnumber'
import InputSwitch from 'primevue/inputswitch'
import MultiSelect from 'primevue/multiselect'
import SelectButton from 'primevue/selectbutton'
import Textarea from 'primevue/textarea'
import Listbox from 'primevue/listbox'
import ToggleButton from 'primevue/togglebutton'
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon'
import Select from 'primevue/select'
import Slider from 'primevue/slider'
// Button
import Button from 'primevue/button'
// Data
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import PickList from 'primevue/picklist'
import VirtualScroller from 'primevue/virtualscroller'
// Panel
import Card from 'primevue/card'
import Accordion from 'primevue/accordion'
import AccordionPanel from 'primevue/accordionpanel'
import AccordionContent from 'primevue/accordioncontent'
import AccordionHeader from 'primevue/accordionheader'
import Divider from 'primevue/divider'
import Fieldset from 'primevue/fieldset'
import Stepper from 'primevue/stepper'
import Step from 'primevue/step'
import StepList from 'primevue/steplist'
import StepPanel from 'primevue/steppanel'
import StepPanels from 'primevue/steppanels'
import ScrollPanel from 'primevue/scrollpanel'
// Overlay
import ConfirmDialog from 'primevue/confirmdialog'
import ConfirmPopup from 'primevue/confirmpopup'
import Tooltip from 'primevue/tooltip'
import OverlayPanel from 'primevue/overlaypanel'
import Popover from 'primevue/popover'
import Drawer from 'primevue/drawer'
import Dialog from 'primevue/dialog'
// File
import FileUpload from 'primevue/fileupload'
// Menu
import ContextMenu from 'primevue/contextmenu'
import Menu from 'primevue/menu'
import MenuBar from 'primevue/menubar'
import Toolbar from 'primevue/toolbar'
// Message
import Message from 'primevue/message'
import InlineMessage from 'primevue/inlinemessage'
// Media
import Image from 'primevue/image'
import ImageCompare from 'primevue/imagecompare'
// Misc
import Avatar from 'primevue/avatar'
import Badge from 'primevue/badge'
import Chip from 'primevue/chip'
import ProgressSpinner from 'primevue/progressspinner'
import Tag from 'primevue/tag'
// Services
import ConfirmationService from 'primevue/confirmationservice'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import SplitButton from 'primevue/splitbutton'
import Panel from 'primevue/panel'
import FloatLabel from 'primevue/floatlabel'
import ToggleSwitch from 'primevue/toggleswitch'
import ProgressBar from 'primevue/progressbar'
import OverlayBadge from 'primevue/overlaybadge'
import Paginator from 'primevue/paginator'
import Password from 'primevue/password'
import Skeleton from 'primevue/skeleton'

export const csPresetNora = definePreset(Nora, {
    semantic: {
        primary: {
            50: '{sky.50}',
            100: '{sky.100}',
            200: '{sky.200}',
            300: '{sky.300}',
            400: '{sky.400}',
            500: '{sky.500}',
            600: '{sky.600}',
            700: '{sky.700}',
            800: '{sky.800}',
            900: '{sky.900}',
            950: '{sky.950}'
        }
    }
})

export const registerPrimeVue = (app: App) => {
    app.use(PrimeVue, {
        theme: {
            preset: csPresetNora,
            options: {
                cssLayer: {
                    name: 'primevue',
                    order: 'tailwind-base, primevue, tailwind-utilities',
                },
                darkModeSelector: '.dark',
            }
        }
    })

    // Form
    app.component('AutoComplete', AutoComplete)
    app.component('Calendar', Calendar)
    app.component('DatePicker', DatePicker)
    app.component('Checkbox', Checkbox)
    app.component('ColorPicker', ColorPicker)
    app.component('Select', Select)
    app.component('InputText', InputText)
    app.component('InputGroup', InputGroup)
    app.component('InputGroupAddon', InputGroupAddon)
    app.component('InputNumber', InputNumber)
    app.component('InputSwitch', InputSwitch)
    app.component('MultiSelect', MultiSelect)
    app.component('SelectButton', SelectButton)
    app.component('Textarea', Textarea)
    app.component('Listbox', Listbox)
    app.component('ToggleButton', ToggleButton)
    app.component('InputIcon', InputIcon)
    app.component('IconField', IconField)
    app.component('FloatLabel', FloatLabel)
    app.component('ToggleSwitch', ToggleSwitch)
    app.component('Slider', Slider)
    app.component('InputMask', InputMask)
    app.component('Password', Password)

    // Button
    app.component('Button', Button)
    app.component('SplitButton', SplitButton)

    // Data
    app.component('DataTable', DataTable)
    app.component('Column', Column)
    app.component('PickList', PickList)
    app.component('VirtualScroller', VirtualScroller)
    app.component('Paginator', Paginator)

    // Panel
    app.component('Card', Card)
    app.component('Divider', Divider)
    app.component('Panel', Panel)
    app.component('Accordion', Accordion)
    app.component('AccordionPanel', AccordionPanel)
    app.component('AccordionContent', AccordionContent)
    app.component('AccordionHeader', AccordionHeader)
    app.component('Fieldset', Fieldset)
    app.component('Stepper', Stepper)
    app.component('Step', Step)
    app.component('StepList', StepList)
    app.component('StepPanel', StepPanel)
    app.component('StepPanels', StepPanels)
    app.component('ScrollPanel', ScrollPanel)

    // Overlay
    app.component('ConfirmDialog', ConfirmDialog)
    app.component('ConfirmPopup', ConfirmPopup)
    app.component('OverlayPanel', OverlayPanel)
    app.directive('tooltip', Tooltip)
    app.component('Popover', Popover)
    app.component('Drawer', Drawer)
    app.component('Dialog', Dialog)

    // File
    app.component('FileUpload', FileUpload)

    // Menu
    app.component('SimpleMenu', Menu)
    app.component('ContextMenu', ContextMenu)
    app.component('MenuBar', MenuBar)
    app.component('Toolbar', Toolbar)

    // Message
    app.component('Message', Message)
    app.component('InlineMessage', InlineMessage)

    // Media
    app.component('Image', Image)
    app.component('ImageCompare', ImageCompare)

    // Misc
    app.component('Avatar', Avatar)
    app.component('Badge', Badge)
    app.component('Chip', Chip)
    app.component('ProgressSpinner', ProgressSpinner)
    app.component('ProgressBar', ProgressBar)
    app.component('Tag', Tag)
    app.component('OverlayBadge', OverlayBadge)
    app.component('Skeleton', Skeleton)

    // Services
    app.component('Toast', Toast)
    app.use(ConfirmationService)
    app.use(ToastService)
}